/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Scan the QR code with your authenticator app, give the device a name, then enter the 6-digit code and your recovery code to confirm." |
*
* @param {Profile_Security_Totp_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_add_description = /** @type {((inputs?: Profile_Security_Totp_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Scanne den QR-Code mit deiner Authenticator-App, gib dem Gerät einen Namen und gib dann den 6-stelligen Code sowie deinen Wiederherstellungscode zur Bestätigung ein.")
	return /** @type {LocalizedString} */ ("Scan the QR code with your authenticator app, give the device a name, then enter the 6-digit code and your recovery code to confirm.")
});